import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { SearchIcon } from '../icons/Icons';
import { openCommandPalette } from '../CommandPalette';
import { Button } from '../ui/Button';

export const Header: React.FC = () => {
  const { user } = useAuth();
  const { theme } = useTheme();

  return (
    <header className="md:hidden flex h-14 items-center justify-between border-b border-border px-4 bg-card/80 backdrop-blur-md shrink-0">
      <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2 group">
        <img 
          src={theme === 'dark' ? "/logos/promptera_logo.png" : "/logos/promptera_logo_dark.png"} 
          alt="Promptera" 
          className="h-7 w-auto object-contain transition-transform group-hover:scale-102" 
        />
      </Link>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => openCommandPalette()}
          className="flex h-9 w-9 items-center justify-center rounded-xl border border-border/80 bg-muted/30 text-muted-foreground hover:text-foreground transition-colors"
          title="Search (⌘K)"
          aria-label="Search"
        >
          <SearchIcon className="h-4 w-4" />
        </button>

        {user ? (
          <Link to={`/profile/${user.uid}`} className="flex items-center">
            <img
              src={user.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.displayName || 'User')}`}
              alt={user.displayName || 'User'}
              className="h-8 w-8 rounded-full border border-border object-cover"
            />
          </Link>
        ) : (
          <Link to="/auth">
            <Button size="sm" className="h-8 text-xs px-3 rounded-lg">Sign In</Button>
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;